import procedures_1 from './procedures/procedures_1';
import procedures_2 from './procedures/procedures_2';
import procedures_3 from './procedures/procedures_3';
import procedures_4 from './procedures/procedures_4';
import procedures_5 from './procedures/procedures_5';
import procedures_6 from './procedures/procedures_6';

export default [
  {
    id: 1,
    imgId: 5,
    name: "Plastická chirurgie",
    icon: "doctor",
    procedures: procedures_1,
    desc: "Kosmetické, plastické zákroky a operace."
  },
  {
    id: 2,
    imgId: 1,
    name: "Laserová estetika",
    icon: "laser",
    procedures: procedures_2,
    desc: "Laser centrum je vybavováno nejnovějšími přístroji."
  },
  {
    id: 3,
    imgId: 2,
    name: "Dermatologie",
    icon: "epidermis",
    procedures: procedures_3,
    desc: "Specializujeme se na lékařskou péči o kůži."
  },
  {
    id: 4,
    imgId: 6,
    name: "ORL - ušní, nosní, krční",
    icon: "ear",
    procedures: procedures_4,
    desc: "Specializovaná ordinace krční, nosní, ušní, otorhinolaryngologie."
  },
  {
    id: 5,
    imgId: 3,
    name: "Obecná a žilní chirurgie",
    icon: "scalpel",
    procedures: procedures_5,
    desc: "Specializujeme se na léčbu křečových žil ve všech stádiích."
  },
  {
    id: 6,
    imgId: 4,
    name: "Ostatní",
    icon: "diet",
    procedures: procedures_6,
    desc: "Komplexní interní vyšetření, předoperační vyšetření."
  },
]



// WEBPACK FOOTER //
// ./src/texts/czech/surgery.js